import { useMutation } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";
import { client } from "../client";

type AddBrandCreatorsPayload = {
  merchantId: string;
  creatorIds: string[];
};

export const useAddBrandCreators = () => {
  return useMutation({
    mutationFn: async (payload: AddBrandCreatorsPayload) => {
      const res = await client.admin["brand-creators"].$post({
        json: payload,
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["admin", "brand-creators", variables.merchantId],
      });
    },
  });
};
